import React, { useEffect } from "react";
import { useParams, Navigate, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "../components/Header";
import SuburbHero from "../components/SuburbHero";
import Stats from "../components/Stats";
import About from "../components/About";
import Services from "../components/Services";
import WhyChooseUs from "../components/WhyChooseUs";
import Products from "../components/Products";
import Privacy from "../components/Privacy";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import StickyQuoteButton from "../components/StickyQuoteButton";
import { findSuburb } from "../suburbs";
import { faqs } from "../mock";

const SuburbLanding = () => {
  const { suburb: slug } = useParams();
  const suburb = findSuburb(slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!suburb) {
    return <Navigate to="/cleaning" replace />;
  }

  const title = `Premium House Cleaning in ${suburb.name}, Brisbane | The Sterling Touch`;
  const description = `Refined, discreet house cleaning in ${suburb.name}. Tailored packages for ${suburb.region.toLowerCase()} homes — fully insured, police checked, satisfaction guaranteed. Personalised quote within 24 hours.`;

  return (
    <div className="min-h-screen bg-cream">
      <SEO
        title={title}
        description={description}
        path={`/cleaning/${suburb.slug}`}
        suburb={suburb.name}
        faqs={faqs}
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Service Areas", path: "/cleaning" },
          { name: suburb.name, path: `/cleaning/${suburb.slug}` },
        ]}
      />
      <StickyQuoteButton />
      <Header />
      <main>
        <SuburbHero
          suburb={suburb.name}
          region={suburb.region}
          blurb={suburb.blurb}
        />

        {/* Breadcrumb-style link back to all areas */}
        <div className="bg-white border-y border-[#ead8c9]">
          <div className="max-w-7xl mx-auto px-6 lg:px-10 py-3 flex items-center gap-2 text-sm text-ink/60">
            <Link to="/" className="hover:text-ink">Home</Link>
            <span>/</span>
            <Link to="/cleaning" className="hover:text-ink">Service Areas</Link>
            <span>/</span>
            <span className="text-ink">{suburb.name}</span>
          </div>
        </div>

        <Stats />
        <About />
        <Services />
        <WhyChooseUs />
        <Products />
        <Testimonials />
        <Privacy />
        <FAQ />
        <Contact />

        {/* Local SEO: link back to all service areas */}
        <section className="bg-white py-16 border-t border-[#ead8c9]">
          <div className="max-w-7xl mx-auto px-6 lg:px-10 text-center">
            <div className="text-xs uppercase tracking-[0.25em] text-[#daae9c]">
              We Also Service
            </div>
            <h2 className="font-serif-display text-3xl md:text-4xl text-ink mt-3">
              Premium cleaning across Brisbane
            </h2>
            <Link
              to="/cleaning"
              className="inline-flex items-center gap-2 mt-6 px-6 h-11 rounded-full border border-ink/20 text-ink hover:bg-ink hover:text-cream transition-colors text-sm"
            >
              <ArrowLeft size={14} />
              View all 20 service areas
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default SuburbLanding;
